<template>
  <div class="Section0" style="layout-grid:15.6000pt;">
      <p class=MsoNormal align=center style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
  mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:center;
  mso-outline-level:1;line-height:50pt;"><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:24.0000pt;
  mso-font-kerning:18.0000pt;">
                  <font face="宋体">万商服</font>APP<font face="宋体">隐私政策</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-weight:bold;font-size:24.0000pt;
  mso-font-kerning:18.0000pt;">
                  <o:p></o:p>
              </span></b></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:0pt;"><b><span
                  style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">引言</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="text-indent:24.0000pt;mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">珠海万达智慧商业科技有限公司</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>
              <font face="Helvetica">“</font>
              <font face="宋体">我们</font>
              <font face="Helvetica">”</font>
              <font face="宋体">）非常重视保护企业用户（以下或称</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="Helvetica">“</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">您</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="Helvetica">”</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">）在使用我们万商服</font>APP<font face="宋体">（以下或称</font>
              <font face="Helvetica">“</font>
              <font face="宋体">平台</font>
              <font face="Helvetica">”</font>
              <font face="宋体">）服务过程中可能涉及的企业用户法定代表人、负责人、员工或您指定的其他实际使用我们服务的人员（以下或称</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="Helvetica">“</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">个人信息主体</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="Helvetica">”</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">）的个人信息及隐私保护。鉴于您在使用服务过程中我们可能会收集或使用个人信息主体提供的个人信息，为向您</font>/<font face="宋体">
                  个人信息主体阐明个人信息收集、使用、共享、管理及保护的规则，特制定本《隐私政策》（以下或称</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="Helvetica">“</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">本隐私政策</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="Helvetica">”</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">）。个人信息主体的个人数据和隐私保护对于我们而言至关重要，始终获得您</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">/</span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">个人信息主体的信任是我们的第一要务。</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">需要特别说明的是，本</font>
              </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  mso-ansi-font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">隐私</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">政策不适用于其他第三方向您提供的服务，第三方向您提供的服务适用其向您另行说明的隐私政策。</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">本隐私政策将帮助您了解以下内容：</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">1<font face="宋体">、我们如何收集和使用个人信息主体的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">2<font face="宋体">、我们如何共享、转让、公开披露个人信息主体的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">3<font face="宋体">、我们如何保护和保存个人信息主体的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">4<font face="宋体">、个人信息主体如何管理个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">5<font face="宋体">、修订和更新</font></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">6<font face="宋体">、如何联系我们</font></span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">本隐私政策适用于我们的平台。本隐私政策与您所使用的用户注册、绑定店铺、会议管理、出门条、</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">在线账单缴费、合同电子签署、广告推广（含保险、银行贷款等广告信息）</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">服务所包括的业务功能（以下统称</font>
                  <font face="Helvetica">“</font>
                  <font face="宋体">我们的产品与</font>
                  <font face="Helvetica">/</font>
                  <font face="宋体">或服务</font>
                  <font face="Helvetica">”</font>
                  <font face="宋体">）息息相关，希望您促使个人信息主体在您使用产品与</font>
                  <font face="Helvetica">/</font>
                  <font face="宋体">或服务前仔细阅读并确认其已经充分理解本隐私政策所写明的内容，并</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">促使个人信息主体</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">
                      可以按照本隐私政策的指引做出其认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与
                  </font>/<font face="宋体">或服务，即意味着同意本隐私政策（含更新版本）内容，并且同意我们按照本隐私政策收集、使用、保存和共享个人信息主体的相关信息。</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">最近更新日期：</font>&nbsp;2023<font face="宋体">年</font>
                  <font face="Helvetica">&nbsp;06&nbsp;</font>
                  <font face="宋体">月</font>
                  <font face="Helvetica">&nbsp;12&nbsp;</font>
                  <font face="宋体">日。</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">如对本隐私政策或相关事宜有任何问题，您可随时通过以下方式联系我们：</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">电子邮件：</font>
              </span></b><u><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(5,99,193);text-decoration:underline;text-underline:single;
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">wic_service@wanda.com.cn</span></u><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">电话：</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">【</font>400-950-6618<font face="宋体">】</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">目录</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">一、</font>
                  <font face="宋体">我们如何收集和使用</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">个人信息主体</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">的个人信息</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">二、</font>
                  <font face="宋体">我们如何共享、转让、公开披露</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">个人信息主体</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">的个人信息</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">三、</font>
                  <font face="宋体">我们如何保护和保存个人信息</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">主体</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">的</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">个人信息</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">四、</font>&nbsp;<font face="宋体">个人信息主体如何管理个人信息</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">五</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">、</font>
                  <font face="宋体">修订和更新</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;"><br></span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">六</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">、</font>
                  <font face="宋体">如何联系我们</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  text-align:left;mso-outline-level:3;line-height:22.4000pt;"><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(20,20,20);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">一、我们如何收集和使用</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">个人信息主体</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(20,20,20);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">的个人信息</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <o:p></o:p>
              </span></b></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">
                      个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括：基本信息（包括个人姓名、个人</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">手机</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">号码）；个人身份信息（包括身份证）；网络身份标识信息（包括系统账号、</font>IP<font face="宋体">地址及与前述有关的密码等）；个人上网记录（包括
                  </font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">软件</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">浏览记录、软件使用记录、点击记录）；个人常用设备信息（包括硬件型号、设备</font>MAC<font face="宋体">
                      地址、操作系统类型、软件列表唯一设备识别码（如</font>
                  <font face="Helvetica">IMEI/android ID/IDFA/OPENUDID/GUID</font>
                  <font face="宋体">等在内的描述个人常用设备基本情况的信息）；</font>
              </span></b><b><u><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;text-decoration:underline;
  text-underline:single;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                      <font face="宋体">
                          个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本隐私政策中涉及的个人敏感信息包括：个人身份信息（包括身份证）；网络身份识别信息（包括账户名、账户昵称及与前述有关的密码）；其他信息（网页浏览记录信息）
                      </font>
                  </span></u></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">。</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">我们仅会出于以下目的，收集和使用</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">个人信息主体</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">的个人信息：</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（一）须授权我们收集和使用个人信息的情形</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们的产品与</font>/<font face="宋体">或服务包含须授权我们收集个人信息方能使用的功能，这些功能包含：用户注册、绑定店铺、会议管理、</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">出门条</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">。为了核实您指定的我们产品与</font>/<font face="宋体">或服务功能使用者（包括您的店员</font>
              <font face="Helvetica">/</font>
              <font face="宋体">店长或其他您指定的个人）个人身份信息真实相符，我们会收集、保存和使用下列相关个人信息才能实现前述功能。如果您的店员</font>
              <font face="Helvetica">/</font>
              <font face="宋体">店长或其他您指定的个人不提供相关信息，他们将无法使用我们提供的相应产品与</font>
              <font face="Helvetica">/</font>
              <font face="宋体">或服务。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">1<font face="宋体">、主要功能及服务（</font></span><span
              style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">基础功能</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">）</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">包括：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">&nbsp;</span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>1<font face="宋体">）用户注册</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">您首先需要注册一个平台账户成为平台用户。当您注册时，您需要至少向我们提供您准备使用的平台功能的</font>
          </span><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">手机号码</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">用于注册，我们将通过向此</font>
          </span><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">手机号码</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">发送短信验证码来验证是否为有效注册用户登录。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>2<font face="宋体">）绑定店铺</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">注册用户的店员</font>/<font face="宋体">
                  店长或其他您指定的个人绑定店铺即视为万达广场下签约商户的员工，万达广场为前述员工提供员工通道供其出入，为保障万达广场及其他商户的财产权益和安全，用户需按平台格式要求提供其指定员工</font>
          </span><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">身份证（含姓名及照片页）图片信息</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">以实现店铺绑定。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>3<font face="宋体">）会议管理</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">平台提供商户会议管理及签到功能，</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">为了保证会议参与者是</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">万达广场下签约商户的员工</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">，用户需要注册且绑定店铺</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>4<font face="宋体">）出门条</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">出门条即指您指定员工携物出广场凭证，为保障广场及广场所有商户的财、物安全，您指定员工须提供其</font>
          </span><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">身份证（含姓名及照片页）图片信息</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">以申请出门条及凭出门条携物出广场。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>
          </span><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">5</span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">）</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">合同电子签署</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">万商服提供合同电子签署功能，作为您</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
  font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">与商铺租赁相关的主体</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（包括但不限于</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
  font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">万达广场商管公司、物业公司、珠海万达商业管理集团股份有限公司等主体</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">）签署合同的平台，我们受您及前述主体的委托处理相关个人信息。为了产生合同信息以及实现合同结束时财务的退款（如有），您需要向我们提供您的</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">姓名</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">、</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">手机号</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">、</font>
          </span><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">身份证号</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">、</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">身份证照片</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">（</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">正反面</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">）</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">、银行卡号、</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">银行卡照片</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">（</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">正面</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">）、</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">开户行及联行号、经营性质、电子邮箱、居住地址信息</font>
              </span></b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">，我们将根据这些信息作为合同签署依据并向</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
  font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">商铺租赁相关的主体传输</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">您的个人信息以便您使用线上合同签署服务和功能。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">2<font face="宋体">、实现相关业务功能可能开启使用者的设备访问权限的逐项列举：
              </font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <div align=center>
          <table class=MsoNormalTable border=0 cellspacing=0 style="">
              <tr style="mso-row-margin-right:1.8000pt;">
                  <td width=318 valign=center style="width:119.5000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:2.2500pt inset rgb(0,0,0);mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal align=center
                          style="mso-pagination:widow-orphan;text-align:center;line-height:33.8000pt;"><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <font face="宋体">业务场景</font>
                              </span></b><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <o:p></o:p>
                              </span></b></p>
                  </td>
                  <td width=412 valign=center style="width:154.7000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:2.2500pt inset rgb(0,0,0);mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal align=center
                          style="mso-pagination:widow-orphan;text-align:center;line-height:33.8000pt;"><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <font face="宋体">场景说明</font>
                              </span></b><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <o:p></o:p>
                              </span></b></p>
                  </td>
                  <td width=363 valign=center style="width:136.3000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:2.2500pt inset rgb(0,0,0);mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal align=center
                          style="mso-pagination:widow-orphan;text-align:center;line-height:33.8000pt;"><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <font face="宋体">访问及使用权限</font>
                              </span></b><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <o:p></o:p>
                              </span></b></p>
                  </td>
                  <td style="mso-cell-special:placeholder;border:none;" width=4 colspan=2>
                      <p></p>
                  </td>
              </tr>
              <tr style="mso-row-margin-right:1.8000pt;">
                  <td width=318 valign=center style="width:119.5000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
  mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;line-height:33.8000pt;"><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">工程报修</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=412 valign=center style="width:154.7000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">工程报修需要上传现场图片，辅助技工了解现场情况</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=363 valign=center style="width:136.3000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">使用设备摄像头权限</font>
                          </span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">,访问设备相册存储权限,
                              写入相册权限</span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td style="mso-cell-special:placeholder;border:none;" width=4 colspan=2>
                      <p></p>
                  </td>
              </tr>
              <tr style="mso-row-margin-right:1.8000pt;">
                  <td width=318 valign=center style="width:119.5000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">扫一扫</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=412 valign=center style="width:154.7000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">扫码时调用手机摄像头扫描条码</font>/二维码或者从相册里选择图片
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=363 valign=center style="width:136.3000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">使用设备摄像头权限</font>
                          </span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">,访问设备相册存储权限,
                              写入相册权限</span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td style="mso-cell-special:placeholder;border:none;" width=4 colspan=2>
                      <p></p>
                  </td>
              </tr>
              <tr style="mso-row-margin-right:1.8000pt;">
                  <td width=318 valign=center style="width:119.5000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">出门条</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=412 valign=center style="width:154.7000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">用户需要上传要携带出门的物品图片</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=363 valign=center style="width:136.3000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">使用设备摄像头权限</font>
                          </span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">,访问设备相册存储权限,
                              写入相册权限</span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td style="mso-cell-special:placeholder;border:none;" width=4 colspan=2>
                      <p></p>
                  </td>
              </tr>
              <tr style="mso-row-margin-right:1.8000pt;">
                  <td width=318 valign=center style="width:119.5000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">上报销售</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=412 valign=center style="width:154.7000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">用户需要上传销售记录图片作为凭证</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=363 valign=center style="width:136.3000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">使用设备摄像头权限</font>
                          </span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">,访问设备相册存储权限,
                              写入相册权限</span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td style="mso-cell-special:placeholder;border:none;" width=4 colspan=2>
                      <p></p>
                  </td>
              </tr>
              <tr style="mso-row-margin-right:1.8000pt;">
                  <td width=318 valign=center style="width:119.5000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;color:rgb(0,0,0);font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                              <font face="宋体">内购会</font>&员工餐
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=412 valign=center style="width:154.7000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">用户发起活动需要上传活动图片作为凭证</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=363 valign=center style="width:136.3000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">使用设备摄像头权限</font>
                          </span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">,访问设备相册存储权限,
                              写入相册权限</span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td style="mso-cell-special:placeholder;border:none;" width=4 colspan=2>
                      <p></p>
                  </td>
              </tr>
              <tr style="height:33.8000pt;mso-row-margin-right:1.8000pt;">
                  <td width=318 valign=center rowspan=3 style="width:119.5000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:none;border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">IM通讯</span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=412 valign=center rowspan=3 style="width:154.7000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:none;border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">在聊天过程中，发送图片</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=363 valign=center rowspan=3 style="width:136.3000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:none;border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">使用设备摄像头权限</font>
                          </span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">,访问设备相册存储权限,
                              写入相册权限</span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td style="mso-cell-special:placeholder;border:none;" width=4 colspan=2>
                      <p></p>
                  </td>
              </tr>
              <tr>
                  <td width=6 valign=center colspan=2 style="width:2.5000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:none;mso-border-right-alt:none;
  border-top:none;mso-border-top-alt:none;border-bottom:none;
  mso-border-bottom-alt:none;">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;"><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p>&nbsp;</o:p>
                          </span></p>
                  </td>
              </tr>
              <tr>
                  <td width=6 valign=center colspan=2 style="width:2.5000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:none;mso-border-right-alt:none;
  border-top:none;mso-border-top-alt:none;border-bottom:none;
  mso-border-bottom-alt:none;">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;"><span
                              style="font-family:'Times New Roman';font-size:10.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p>&nbsp;</o:p>
                          </span></p>
                  </td>
              </tr>
              <tr>
                  <td width=318 valign=center style="width:119.5000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;"><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">线上合同签署</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=412 valign=center style="width:154.7000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;"><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">用户需要上传身份证、银行卡照片</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=363 valign=center style="width:136.3000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;"><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">使用设备摄像头权限</font>
                          </span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">,访问设备相册存储权限,
                              写入相册权限</span><span
                              style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=6 valign=center colspan=2 style="width:2.5000pt;padding:0.7500pt 0.7500pt 0.7500pt 0.7500pt ;border-left:none;
  mso-border-left-alt:none;border-right:none;mso-border-right-alt:none;
  border-top:none;mso-border-top-alt:none;border-bottom:none;
  mso-border-bottom-alt:none;">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;"><span
                              style="font-family:'Times New Roman';font-size:10.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p>&nbsp;</o:p>
                          </span></p>
                  </td>
              </tr>
          </table>
      </div>
      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">为了便于您使用，在您使用应用过程中我们会询问您是否同意开启上述权限。您可以在设备系统中的设置功能中逐项查看您上述权限的开启状态，并可以决定将这些权限随时的开启或关闭
              </font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">(<font face="宋体">我们会指引您在您的设备系统中完成设置</font>
              <font face="Helvetica">)</font>
              <font face="宋体">。</font>
          </span><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">
                      请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。
                  </font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">3<font face="宋体">、平台涉及个人信息使用的</font>
              <font face="Helvetica">SDK</font>
              <font face="宋体">相关情况逐项列举：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <div align=center>
          <table class=MsoNormalTable border=0 cellspacing=0 style="">
              <tr>
                  <td width=299 valign=center style="width:112.2500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:2.2500pt inset rgb(0,0,0);mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal align=center
                          style="mso-pagination:widow-orphan;text-align:center;line-height:33.8000pt;"><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <font face="宋体">第三方</font>SDK类型
                              </span></b><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <o:p></o:p>
                              </span></b></p>
                  </td>
                  <td width=213 valign=center style="width:79.9500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:2.2500pt inset rgb(0,0,0);mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal align=center
                          style="mso-pagination:widow-orphan;text-align:center;line-height:33.8000pt;"><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <font face="宋体">使用业务场景</font>
                              </span></b><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <o:p></o:p>
                              </span></b></p>
                  </td>
                  <td width=476 valign=center style="width:178.7500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:2.2500pt inset rgb(0,0,0);mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal align=center
                          style="mso-pagination:widow-orphan;text-align:center;line-height:33.8000pt;"><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">SDK所需用户信息</span></b><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <o:p></o:p>
                              </span></b></p>
                  </td>
                  <td width=147 valign=center style="width:55.3500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:2.2500pt inset rgb(0,0,0);mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal align=center
                          style="mso-pagination:widow-orphan;text-align:center;line-height:33.8000pt;"><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <font face="宋体">使用目的</font>(功能)
                              </span></b><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <o:p></o:p>
                              </span></b></p>
                  </td>
              </tr>
              <tr>
                  <td width=299 valign=center style="width:112.2500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">神策数据</font>&nbsp;SDK
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=213 valign=center style="width:79.9500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal align=center
                          style="mso-pagination:widow-orphan;text-align:center;line-height:33.8000pt;"><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <font face="宋体">登录使用</font>
                              </span></b><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                                  <o:p></o:p>
                              </span></b></p>
                  </td>
                  <td width=476 valign=center style="width:178.7500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;color:rgb(71,86,105);font-size:12.0000pt;
  mso-font-kerning:0.0000pt;background:rgb(255,255,255);mso-shading:rgb(255,255,255);">
                              <font face="宋体">设备信息（</font>IDFA、操作系统、设备型号、设备制造商、系统版本、AndroidID、IMEI 以及 MAC
                              地址等）、联网信息（$carrier、$network_type 以及 $wifi 等）
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=147 valign=center style="width:55.3500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  text-align:left;line-height:33.8000pt;"><span style="font-family:宋体;color:rgb(71,86,105);font-size:12.0000pt;
  mso-font-kerning:0.0000pt;background:rgb(255,255,255);mso-shading:rgb(255,255,255);">
                              <font face="宋体">数据分析</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
              </tr>
              <tr>
                  <td width=299 valign=center style="width:112.2500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">第三方登录类</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=213 valign=center style="width:79.9500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">微信登录</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=476 valign=center style="width:178.7500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">存储权限、读取设备信息、读取网络状态、读取</font>WIFI状态
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=147 valign=center style="width:55.3500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">登录和地理位置信息获取</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
              </tr>
              <tr>
                  <td width=299 valign=center style="width:112.2500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">基础功能类</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=213 valign=center style="width:79.9500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">图片下载</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=476 valign=center style="width:178.7500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">存储权限、读取设备信息、读取网络状态、读取</font>WIFI状态
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=147 valign=center style="width:55.3500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">图片存储</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
              </tr>
              <tr>
                  <td width=299 valign=center style="width:112.2500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">框架类</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=213 valign=center style="width:79.9500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">图像视频处理</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=476 valign=center style="width:178.7500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">存储权限、读取设备信息、读取网络状态、读取</font>WIFI状态
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=147 valign=center style="width:55.3500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">图形视频处理</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
              </tr>
              <tr>
                  <td width=299 valign=center style="width:112.2500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">框架类</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=213 valign=center style="width:79.9500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">二维码扫描</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=476 valign=center style="width:178.7500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">存储权限、读取设备信息、读取网络状态、读取</font>WIFI状态、拍照权限
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=147 valign=center style="width:55.3500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">二维码扫描</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
              </tr>
              <tr>
                  <td width=299 valign=center style="width:112.2500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">框架类</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=213 valign=center style="width:79.9500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">上拉刷新</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=476 valign=center style="width:178.7500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">存储权限、读取设备信息、读取网络状态、读取</font>WIFI状态
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=147 valign=center style="width:55.3500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">刷新</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
              </tr>
              <tr>
                  <td width=299 valign=center style="width:112.2500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">框架类</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=213 valign=center style="width:79.9500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">下拉刷新</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=476 valign=center style="width:178.7500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">存储权限、读取设备信息、读取网络状态、读取</font>WIFI状态
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=147 valign=center style="width:55.3500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">刷新</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
              </tr>
              <tr>
                  <td width=299 valign=center style="width:112.2500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">框架类</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=213 valign=center style="width:79.9500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">生成二维码</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=476 valign=center style="width:178.7500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">存储权限、读取设备信息、读取网络状态、读取</font>WIFI状态
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=147 valign=center style="width:55.3500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">出门条凭证</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
              </tr>
              <tr>
                  <td width=299 valign=center style="width:112.2500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">框架类</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=213 valign=center style="width:79.9500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">生成条形码</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=476 valign=center style="width:178.7500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">存储权限、读取设备信息、读取网络状态、读取</font>WIFI状态
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=147 valign=center style="width:55.3500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">出门条凭证</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
              </tr>
              <tr>
                  <td width=299 valign=center style="width:112.2500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">社交类</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=213 valign=center style="width:79.9500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">微信分享</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=476 valign=center style="width:178.7500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">存储权限、读取设备信息、读取网络状态、读取</font>WIFI状态
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=147 valign=center style="width:55.3500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">店长通知店员</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
              </tr>
              <tr>
                  <td width=299 valign=center style="width:112.2500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:2.2500pt inset rgb(0,0,0);
  mso-border-left-alt:2.2500pt inset rgb(0,0,0);border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">推送类</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=213 valign=center style="width:79.9500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">腾讯云推送</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=476 valign=center style="width:178.7500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">存储权限、读取设备信息、读取网络状态、读取</font>WIFI状态、修改设置权限
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
                  <td width=147 valign=center style="width:55.3500pt;padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;
  mso-border-left-alt:none;border-right:2.2500pt inset rgb(0,0,0);mso-border-right-alt:2.2500pt inset rgb(0,0,0);
  border-top:none;mso-border-top-alt:2.2500pt inset rgb(0,0,0);border-bottom:2.2500pt inset rgb(0,0,0);
  mso-border-bottom-alt:2.2500pt inset rgb(0,0,0);">
                      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;">
                          <span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <font face="宋体">信息推送</font>
                          </span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                              <o:p></o:p>
                          </span></p>
                  </td>
              </tr>
          </table>
      </div>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（二）以下情形中，我们收集、使用个人信息无需征得个人信息主体的授权同意：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">1<font face="宋体">、与个人信息控制者履行法律法规规定的义务相关的；</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">2<font face="宋体">、与国家安全、国防安全直接相关的；</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">3<font face="宋体">、与公共安全、公共卫生、重大公共利益直接相关的；</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">4<font face="宋体">、与犯罪侦查、起诉、审判和判决执行等直接相关的；</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">5<font face="宋体">
                  、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">6<font face="宋体">、所涉及的个人信息是个人信息主体自行向社会公众公开的；
              </font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">7<font face="宋体">、根据个人信息主体要求签订和履行合同所必需的；</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">8<font face="宋体">
                  、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">9<font face="宋体">
                  、维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">10<font face="宋体">、为开展合法的新闻报道所必需的；</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">11<font face="宋体">、法律法规规定的其他情形。</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（三）我们从第三方获得个人信息的情形（个人信息的间接获取）</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们可能从第三方获取您授权共享的账户信息（头像、昵称等），并在您同意本隐私政策后将您的第三方账户与您的平台账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与
              </font>/<font face="宋体">或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用个人信息主体的个人信息。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们承诺，我们从第三方间接获取的个人信息的数量为实现平台产品业务功能所必须的最少数量。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">
                  我们承诺，在从第三方间接获取个人信息时，要求第三方说明个人信息来源，并会对其个人信息来源的合法性进行确认；我们将了解并审慎注意，第三方已获得个人信息主体对其个人信息处理的授权同意范围，包括使用目的，个人信息主体是否授权同意转让、共享、公开披露等。我们开展业务所需进行的个人信息处理活动超出该授权同意范围的，将在获取个人信息主体的个人信息后的合理期限内或处理个人信息主体的个人信息前，征得个人信息主体的明示同意或单独同意（涉及个人敏感信息的情形）。
              </font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（四）我们在您使用产品及服务过程中收集的信息</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们会收集关于您使用我们产品或服务以及使用方式的信息，这些信息包括：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">设备信息：我们会根据您在软件安装及</font>/<font face="宋体">
                  或使用中授予的具体权限，接收并记录您所使用的设备相关信息（设备型号、操作系统版本、设备设置、唯一设备标识符、设备环境等软硬件特征信息）、设备所在位置相关信息（</font>
              <font face="Helvetica">IP</font>
              <font face="宋体">地址、</font>
              <font face="Helvetica">GPS</font>
              <font face="宋体">位置以及能够提供相关信息的</font>
              <font face="Helvetica">WLAN</font>
              <font face="宋体">接入点、蓝牙和基站等传感器信息）。如果您在安装及</font>
              <font face="Helvetica">/</font>
              <font face="宋体">或使用过程中拒绝授予我们相应权限的，我们并不会记录您上述对应的信息。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。包括搜索查询内容、</font>IP<font
                  face="宋体">地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">
                  请您理解，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。除非将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，那么在结合使用期间，这类非个人信息将被视为个人信息，我们会将该类个人信息做匿名化、去标识化处理（取得您的授权或法律法规另有规定的情况除外）。
              </font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">当您与我们联系时，为验证您的身份，帮助您解决问题，我们可能会记录您与我们的对话并收集其他为解决问题所需的必要信息。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（五）个人信息使用的规则</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">1<font face="宋体">、我们会根据本隐私政策的约定并为实现我们的产品与</font>
              <font face="Helvetica">/</font>
              <font face="宋体">或服务功能对所收集的个人信息进行使用。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">2<font face="宋体">
                  、在收集个人信息主体的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。
              </font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">3<font face="宋体">、请注意，您在使用我们的产品与</font>
              <font face="Helvetica">/</font>
              <font face="宋体">或服务时所提供的所有个人信息，除非您</font>
              <font face="Helvetica">/</font>
              <font face="宋体">个人信息主体删除或您</font>
              <font face="Helvetica">/</font>
              <font face="宋体">个人信息主体通过系统设置拒绝我们收集，否则将在您使用我们的产品与</font>
              <font face="Helvetica">/</font>
              <font face="宋体">或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除个人信息主体的个人信息或对个人信息进行匿名化处理。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">4<font face="宋体">、我们会对我们的产品与</font>
              <font face="Helvetica">/</font>
              <font face="宋体">或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与</font>
              <font face="Helvetica">/</font>
              <font face="宋体">或服务的整体使用趋势。但这些统计信息不包含个人信息主体的任何身份识别信息。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">5<font face="宋体">
                  、当我们展示个人信息主体的个人信息时，我们会采用包括内容替换、匿名处理方式对个人信息主体的信息进行脱敏，以保护个人信息主体的信息安全。</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">6<font face="宋体">
                  、我们不会将个人信息主体提供的个人信息用于本隐私政策未载明的其它用途。</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  text-align:left;mso-outline-level:3;line-height:22.4000pt;"><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(20,20,20);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">二、我们如何共享、转让、公开披露</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">个人信息主体的</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(20,20,20);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">个人信息</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <o:p></o:p>
              </span></b></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（一）共享</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p>&nbsp;</o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">1</span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">、为了更好的向您提供平台服务，我们会与万达广场所属公司</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
  font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">包括相关万达广场商管公司、物业公司、珠海万达商业管理集团股份有限公司等</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">）</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">相关系统共享您的个人信息</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">（包括但不限于姓名、手机号、身份证号</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">）</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">和企业信息（</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">包括但不限于企业名称、统一社会信用代码、企业法定代表人姓名</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">及</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">身份证号、企业银行账号</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">及</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">开户行等基础信息</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">商户信息、经营报表、账单信息、历史数据及基于前述信息所合成之其他经营信息</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">）。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:Helvetica;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">2</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:Helvetica;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">、</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:PingFangSC-Regular;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">在您自主通过本平台提供链接跳转至第三方平台使用第三方服务时</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">（包括但不限于营销服务、信贷服务</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">、保险服务及</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">其他服务）</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:PingFangSC-Regular;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">，我们将依据服务内容及服务方的申请向服务方共享您的</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:PingFangSC-Regular;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">个人信息及</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">企业信息</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:PingFangSC-Regular;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">，</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:PingFangSC-Regular;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">以便您能够顺利使用</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:PingFangSC-Regular;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">第三方的相关产品或服务。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">但以下情形除外：</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <o:p></o:p>
              </span></b></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">（</font>1<font face="宋体">）按照国家法律法规规定，事先获得个人信息主体明确或单独的同意或授权；</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">（</font>2<font face="宋体">）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供。</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">3<font face="宋体">
                  、我们已知晓对外共享、转让、公开披露个人信息所承担的相应法律责任。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。
              </font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（二）转让</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们不会将个人信息主体的个人信息转让给任何公司、组织和个人，但以下情况除外：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">1<font face="宋体">、事先获得个人信息主体明确的同意或授权；</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">2<font face="宋体">
                  、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">3<font face="宋体">
                  、在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向个人信息主体征求授权同意。</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（三）公开披露</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露个人信息：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">1<font face="宋体">
                  、在个人信息主体明确同意的披露方式下披露个人信息主体所指定的个人信息；</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">2<font face="宋体">
                  、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供个人信息主体的个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露个人信息主体的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。
              </font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">以下情形中，共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">1<font face="宋体">
                  、根据法律法规的规定或行政、司法机构、国家部门等有权机关的要求依法提供的；</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">2<font face="宋体">
                  、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到个人信息主体本人同意的；</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">3<font face="宋体">、个人信息主体自行向社会公众公开的个人信息；</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">4<font face="宋体">
                  、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">5<font face="宋体">
                  、符合与个人信息主体签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">6<font face="宋体">、基于符合法律法规的社会公共利益的需要。</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">
                      根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向个人信息主体通知并征得个人信息主体的同意。
                  </font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <o:p></o:p>
              </span></b></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">三、我们如何使用</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">Cookie<font face="宋体">和同类技术</font></span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <o:p></o:p>
              </span></b></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">万商服不使用</font>
                  <font face="Helvetica">C</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">ookie</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">，</font>
              </span></b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">但会使用</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">localStorage</span></b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">存储和获得用户登录信息。</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <o:p></o:p>
              </span></b></p>
      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  text-align:left;mso-outline-level:3;line-height:22.4000pt;"><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(20,20,20);
  font-weight:bold;font-size:13.5000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">四</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(20,20,20);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">、我们如何保护和保存个人信息主体的个人信息</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <o:p></o:p>
              </span></b></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（一）我们保护个人信息的技术与措施</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们非常重视个人信息安全，并采取一切合理可行的措施，保护个人信息：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">1<font face="宋体">、数据安全技术措施</font></span><span
              style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">平台的服务采取了传输层安全协议等加密技术，通过</font>https<font face="宋体">等方式提供浏览服务，确保用户数据在传输过程中的安全。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们采取加密技术对个人信息进行加密保存，并通过隔离技术进行隔离。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">在个人信息使用时，我们会采用包括内容替换、</font>SHA256<font face="宋体">在内多种数据脱敏技术增强个人信息在使用中安全性。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们采用代码安全自动检查、数据访问日志分析技术进行个人信息安全审计。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">2<font face="宋体">、我们为保护个人信息采取的其他安全措施</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们通过建立数据分类分级制度、数据安全管理规范来管理规范个人信息的存储和使用。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们建立数据安全管理组织来推进和保障个人信息安全。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们存储个人数据的底层云技术取得了数据中心联盟颁发的</font>
              <font face="Helvetica">“</font>
              <font face="宋体">可信云</font>
              <font face="Helvetica">”</font>
              <font face="宋体">认证。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">3<font face="宋体">、我们仅允许有必要知晓这些信息的万达广场所属公司（包含
              </font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
  font-size:12.0000pt;mso-font-kerning:1.0000pt;">
              <font face="宋体">相关万达广场商管公司、物业公司、珠海万达商业管理集团股份有限公司等</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">
                  ）及我们的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与平台的合作关系。
              </font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">4<font face="宋体">
                  、我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本隐私政策所述目的所需的期限内保留个人信息，除非需要延长保留期或受到法律的允许。</font></span><span
              style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">5<font face="宋体">
                  、互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议个人信息主体使用此类工具时请使用复杂密码，并注意保护其个人信息安全。</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">6<font face="宋体">
                  、互联网环境并非百分之百安全，我们将尽力确保或担保个人信息主体发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致个人信息主体的合法权益受损，我们将承担相应的法律责任。
              </font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">7<font face="宋体">、如果您</font>
              <font face="Helvetica">/</font>
              <font face="宋体">
                  个人信息主体对我们的个人信息保护有任何疑问，可通过本隐私政策最下方约定的联系方式联系我们。如发现个人信息主体的个人信息泄密，请立即通过本隐私政策最下方【如何联系我们】约定的联系方式联络我们，以便我们采取相应措施。
              </font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（二）个人信息的保存</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">1<font face="宋体">
                  、原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">
                  一般而言，若法律法规有强制的留存要求，我们将依法进行留存。例如：《中华人民共和国网络安全法》要求采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月。若无强制要求，我们将仅在为实现目的所必需的最短时间内保留您的个人信息，例如
              </font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">: </span><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">手机号码</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">:</span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">若您需要使用</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">万商服的</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">服务，我们需要</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">在服务期间</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">保存您的手机号码，以保证您正常使用该服务。</font>
          </span><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">合同信息</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">:</span></b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们会永久保存合同信息，除非法律另有规定</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">如果我们更改数据存储时间，会另行提前通知并严格按照法律法规规定执行。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">2<font face="宋体">
                  、请注意，当您成功申请注销用户账户后，我们将在您提出申请后完成账户注销审核，审核通过后，我们将对个人信息主体的个人信息进行删除或匿名化处理。</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">3<font face="宋体">
                  、如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对个人信息主体的个人信息进行删除或匿名化处理。</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  text-align:left;mso-outline-level:3;line-height:22.4000pt;"><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(20,20,20);
  font-weight:bold;font-size:13.5000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">五</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(20,20,20);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">、</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">个人信息主体</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(20,20,20);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">如何管理个人信息</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(20,20,20);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <o:p></o:p>
              </span></b></p>
      <p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
  mso-margin-bottom-alt:auto;text-indent:24.0000pt;mso-char-indent-count:2.0000;
  mso-pagination:widow-orphan;text-align:left;mso-outline-level:3;
  line-height:22.4000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">我们</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">非常重视</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">个人信息主体</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">对个人信息的关注，并尽全力保护</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">个人信息主体</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">对于</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">其</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">个人信息访问、更正、删除以及撤回同意的权利，以使</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">个人信息主体</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">拥有充分的能力保障</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">其</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">隐私和安全。</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">个人信息主体</font>
          </span><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">的权利包括：</font>
              </span></b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">1<font face="宋体">、访问和更正个人信息主体的个人信息</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>1<font face="宋体">）账户信息</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">平台端具体路径为：账户名称、个人资料信息、账户密码、电话号码：首页</font>--“<font face="宋体">我的</font>
              <font face="Helvetica">”</font>
              <font face="宋体">进入个人资料；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>2<font face="宋体">
                  ）对于在使用我们的产品或服务过程中产生的其他个人信息需要访问或更正，请随时联系我们。我们会根据本隐私政策所列明的方式响应个人信息主体的请求。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">2<font face="宋体">、删除个人信息</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">在以下情形中，个人信息主体可以向我们提出删除个人信息的请求：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>1<font face="宋体">）如果我们处理个人信息的行为违反法律法规；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>2<font face="宋体">）如果我们收集、使用个人信息主体的个人信息，却未征得个人信息主体的同意；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>3<font face="宋体">）如果我们处理个人信息的行为违反了与个人信息主体的约定；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>4<font face="宋体">）如果我们终止服务及运营。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">
                  若我们决定响应个人信息主体的删除请求，我们还将同时通知从我们获得个人信息主体个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得个人信息主体的独立授权。当个人信息主体从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
              </font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">3<font face="宋体">、改变个人信息主体授权同意的范围或撤回个人信息主体的授权
              </font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">个人信息主体可以通过删除信息、关闭设备功能、在平台中进行</font>
              <font face="Helvetica">“</font>
              <font face="宋体">隐私设置</font>
              <font face="Helvetica">”</font>
              <font face="宋体">等方式改变个人信息主体授权我们继续收集个人信息的范围或撤回个人信息主体的授权。个人信息主体也可以通过注销账户的方式，撤回我们继续收集个人信息的全部授权。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">
                  请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当个人信息主体撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理个人信息主体相应的个人信息。但个人信息主体撤回同意或授权的决定，不会影响此前基于个人信息主体的授权而开展的个人信息处理。
              </font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">4<font face="宋体">、注销账户</font></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">您可以通过邮箱：</font>wic_service@wanda.com.cn<font face="宋体">联系我们，对您的账户进行注销。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">
                  我们在此善意地提醒您，您注销账户的行为会给您带来诸多不便，且注销平台账户后，我们会将个人信息主体的个人信息在平台系统中去除，使其保持不可被检索、访问的状态，或对其进行匿名化处理。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>1<font face="宋体">）平台账户一旦被注销将不可恢复，请您保存好服务的交易凭证、票据等资料，否则您有可能无法享受售后服务。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>2<font face="宋体">）如果您的平台账户同时是万商服平台商家店铺的绑定账户名，您需先解除相关绑定；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>3<font face="宋体">）注销平台账户，您将无法再使用平台账户，也将无法找回平台账户中及与平台账户相关的任何内容或信息，包括但不限于：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">①</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">您将无法登录、使用本平台账户；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">②</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">本平台账户的资料和历史信息（包括但不限于用户名、头像等）都将无法找回；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">③</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">
                  您通过平台账户使用、授权登录或绑定平台账户后使用的平台相关或第三方的其他服务的所有记录将无法找回。您将无法再登录、使用前述服务，您曾获得的余额、优惠券、积分、资格、订单、等各项权益及其他卡券等视为您自行放弃，将无法继续使用。您理解并同意，平台无法协助您重新恢复前述服务。请您在提交注销申请前，务必先了解您须解绑的其他相关账户信息，具体可与我们的客服联系。
              </font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>4<font face="宋体">）注销平台账户并不代表平台账户注销前的账户行为和相关责任得到豁免或减轻。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">有下列情形之一的，我们有权决定暂不予注销您的平台账户信息而无需另行得到您的同意：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>i<font face="宋体">）账户内有未完成的订单和服务，对平台或第三方有影响的；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>ii<font face="宋体">）在您申请平台账户注销期间，如果您的平台账户涉及争议或纠纷的，包括但不限于投诉、举报、诉讼、仲裁、国家有关机关调查等；
              </font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>iii<font face="宋体">）其他法律法规规定的不得注销或删除的内容。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">5<font face="宋体">、响应个人信息主体的请求</font></span><span
              style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">如果个人信息主体无法通过上述方式访问、更正其个人信息，或个人信息主体需要访问、更正使用产品与</font>/<font face="宋体">
                  或服务时所产生的其他个人信息，或个人信息主体认为我们存在任何违反法律法规或与个人信息主体关于个人信息的收集或使用的约定，个人信息主体均可以发送电子邮件至【</font>
              <font face="Helvetica">wic_service@wanda.com.cn</font>
              <font face="宋体">
                  】或通过本隐私政策中的其他方式与我们联系。为了保障安全，我们可能需要个人信息主体提供书面请求，或提供个人信息主体的身份证明文件，我们将在收到个人信息主体反馈并验证个人信息主体的身份后的</font>
              <font face="Helvetica">15</font>
              <font face="宋体">
                  天内答复个人信息主体的请求。对于个人信息主体合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
              </font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">在以下情形中，按照法律法规要求，我们将无法响应个人信息主体的请求：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>1<font face="宋体">）与个人信息控制者履行法律法规规定的义务相关的；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>2<font face="宋体">）与国家安全、国防安全有关的；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>3<font face="宋体">）与公共安全、公共卫生、重大公共利益有关的；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>4<font face="宋体">）与犯罪侦查、起诉和审判等有关的；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>5<font face="宋体">）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>6<font face="宋体">）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>7<font face="宋体">）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>8<font face="宋体">）涉及商业秘密的。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  text-align:left;mso-outline-level:3;line-height:22.4000pt;"><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(20,20,20);
  font-weight:bold;font-size:13.5000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">六</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(20,20,20);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">、修订和更新</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <o:p></o:p>
              </span></b></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">1<font face="宋体">
                  、为给您提供更好的服务以及随着平台业务的发展，本隐私政策也会随之更新。但未经个人信息主体明确同意，我们不会削减个人信息主体依据本隐私政策所应享有的权利。我们会通过在平台上发出更新版本并在生效前通过公告或以其他适当方式提醒您
              </font>
              <font face="Helvetica">/</font>
              <font face="宋体">个人信息主体相关内容的更新，也请您</font>
              <font face="Helvetica">/</font>
              <font face="宋体">个人信息主体访问平台以便及时了解最新的隐私政策。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">2<font face="宋体">
                  、对于重大变更，我们还会提供更为显著的通知（我们会通过浏览页面做特别提示等方式，说明隐私政策的具体变更内容），并再次征得您</font>
              <font face="Helvetica">/</font>
              <font face="宋体">个人信息主体的同意。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">本隐私政策所指的重大变更包括：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>1<font face="宋体">）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>2<font face="宋体">）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>3<font face="宋体">）个人信息共享、转让或公开披露的主要对象发生变化；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>4<font face="宋体">）个人信息主体参与个人信息处理方面的权利及其行使方式发生重大变化；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>5<font face="宋体">）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>6<font face="宋体">）个人信息安全影响评估报告表明存在高风险时。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">3<font face="宋体">、我们还会将本策略的旧版本存档，供您</font>
              <font face="Helvetica">/</font>
              <font face="宋体">个人信息主体查阅。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  text-align:left;mso-outline-level:3;line-height:22.4000pt;"><b><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(20,20,20);
  font-weight:bold;font-size:13.5000pt;mso-font-kerning:0.0000pt;">
                  <font face="宋体">七</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(20,20,20);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <font face="宋体">、如何联系我们</font>
              </span></b><b><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-weight:bold;font-size:13.5000pt;
  mso-font-kerning:0.0000pt;">
                  <o:p></o:p>
              </span></b></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">1<font face="宋体">、如您</font>
              <font face="Helvetica">/</font>
              <font face="宋体">个人信息主体对本隐私政策或个人信息的相关事宜有任何问题、意见或建议，请通过发送邮件至【</font>
              <font face="Helvetica">wic_service@wanda.com.cn</font>
              <font face="宋体">】。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">2<font face="宋体">
                  、一般情况下，我们将在十五天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了个人信息主体的合法权益，个人信息主体还可以通过以下外部途径寻求解决方案：</font>
              </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>1<font face="宋体">）向被告所在地人民法院提起民事诉讼；</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">（</font>2<font face="宋体">）向中央网信办举报（举报中心网址为：</font>
              <font face="Helvetica">http://www.12377.cn</font>
              <font face="宋体">，举报电话为：</font>
              <font face="Helvetica">12377</font>
              <font face="宋体">）。</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-pagination:widow-orphan;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">3<font face="宋体">、产品运营者基本情况</font></span><span
              style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">公司名称：</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">珠海万达智慧商业科技有限公司</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">注册地址：</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">珠海市横琴新区环岛东路</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">3000<font face="宋体">号</font>
              <font face="Helvetica">1203</font>
              <font face="宋体">室</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">常用办公地址：</font>
          </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:Helvetica;
  mso-hansi-font-family:Helvetica;mso-bidi-font-family:Helvetica;color:rgb(0,0,0);
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">中国北京市朝阳区建国路</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">93<font face="宋体">号万达广场</font>
              <font face="Helvetica">B</font>
              <font face="宋体">座</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;
  text-align:left;line-height:33.8000pt;"><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <font face="宋体">个人信息保护相关负责人联系方式：</font>
          </span><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(44,62,80);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
              <o:p></o:p>
          </span></p>
      <p class=MsoNormal><u><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);text-decoration:underline;text-underline:single;
  font-size:12.0000pt;mso-font-kerning:0.0000pt;">wic_service@wanda.com.cn</span></u><span style="mso-spacerun:'yes';font-family:Helvetica;mso-fareast-font-family:宋体;
  color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">400-950-6618</span><span style="mso-spacerun:'yes';font-family:等线;mso-bidi-font-family:'Times New Roman';
  font-size:10.5000pt;mso-font-kerning:1.0000pt;">
              <o:p></o:p>
          </span></p>
  </div>
</template>

<script>
export default {}
</script>

<style></style>